import {
  httpClient,
  apiRoutes,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

export type PayBalanceRes = {
  status: string;
  data?: {
    redirect_url?: string;
  };
};

export type PaymentCardRequestParams = {
  payment_provider: 'epay';
  return_url: string;
  card_type: string | null;
};

export const postSourceCardFn = async (body: PaymentCardRequestParams) => {
  const response = await httpClient.post(apiRoutes.payment.source_cards, body);
  return response.data;
};

export const usePostSourceCardMutation = (
  opts?: UseMutationOptions<
    PayBalanceRes,
    DefaultQueryError,
    PaymentCardRequestParams
  >
) =>
  useMutation<PayBalanceRes, DefaultQueryError, PaymentCardRequestParams>({
    mutationFn: postSourceCardFn,
    ...opts,
  });
